import React from "react";

import styles from "./AnswerStats.module.scss";

type AnswerStatsProps = {
  answered: number;
  total: number;
  unanswered: number;
};

export const AnswerStats: React.FC<AnswerStatsProps> = ({
  answered,
  total,
  unanswered,
}) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.result}>
        <span className={styles.answered}>{answered}</span>
        <span className={styles.line}>/</span>
        <span className={styles.total}>{total}</span>
      </p>
      <p className={styles.text}>人が回答済み（{unanswered}人が未回答です）</p>
    </div>
  );
};

export default AnswerStats;
